module.exports = __webpack_public_path__ + "static/img/feixue.e4d1786d.png";